(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    // Mobilmenyns bildbanner som öppnar en annan låda (t.ex. quizet): stäng menyn först och
  // öppna sedan lådan – annars ligger menyn kvar under, och fokusfällorna krockar när de
  // två lådorna stängs och öppnas samtidigt. Fokus går tillbaka till menyknappen efteråt.
  document.addEventListener(
    'click',
    async (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('.menu-drawer__promo [aria-controls]') : null;
      if (!trigger) return;

      const target = document.getElementById(trigger.getAttribute('aria-controls'));
      const menu = trigger.closest('menu-drawer');
      if (!target || typeof target.show !== 'function' || !menu || !menu.open) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      // Övergången brukar ta ~0,5 s; vänta inte längre än 0,7 s om den inte rapporterar klart
      await Promise.race([menu.hide(), new Promise((resolve) => setTimeout(resolve, 700))]);
      target.show(document.querySelector('button[aria-controls="MenuDrawer"]'));
    },
    { capture: true }
  );
  } catch(e) { console.error(e); }
})();

})();
